module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/ISO 450012018.5dd17b33.png";